<template>
  <div id="app">
    <K-HeadBar @UpdateHead="UpdateHead"></K-HeadBar>
    <K-LeftNav @LoadingCompleted="LoadingCompleted" ref="LeftNav"></K-LeftNav>
    <router-view />
  </div>
</template>

<script>
  import HeadBar from '@/components/common/HeadBar.vue'
  import LeftNav from '@/components/common/LeftNav.vue'
  export default {
    name: 'App',
    provide() {
      return {
        isLoad: false,
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    components: {
      'K-HeadBar': HeadBar,
      'K-LeftNav': LeftNav
    },
    methods: {
      UpdateHead () {
        var self = this;
        if(self.isLoad){
          self.$refs.LeftNav.NavMain()
        }else{
          setTimeout(function(){
            self.UpdateHead();
          },100)
        }
      },
      LoadingCompleted () {  //左侧导航栏加载完成
        this.isLoad = true;
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => {
          this.isRouterAlive = true
        })
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .home-bullet-active{
    opacity: 1;
    background-color: #f60;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue